import LogRocket from 'logrocket'

import { getLogRocketApiKey } from 'src/utils/env'

import { ServiceBase } from './ServiceBase'

type LogRocketConfig = {
    persistence?: 'localStorage' | 'sessionStorage' | 'memory'
    disableCookie?: boolean
    crossSubdomainCookie?: boolean
    disableSessionRecording?: boolean
}

class WebSessionRecordingService extends ServiceBase {
    constructor() {
        super({ blockedEnvs: ['dev'] })
    }

    init() {
        const config: LogRocketConfig = {
            persistence: 'localStorage',
            disableCookie: true,
            crossSubdomainCookie: false,
            disableSessionRecording: false,
        }

        LogRocket.init(getLogRocketApiKey()!, config as Parameters<typeof LogRocket.init>[1])
    }

    identify(id: string) {
        LogRocket.identify(id)
    }

    getSessionURL(callback: (sessionURL: string) => void) {
        return LogRocket.getSessionURL(callback)
    }
}

export const webSessionRecordingService = new WebSessionRecordingService()
